module.exports = __webpack_public_path__ + "img/packages/top_row_stb.de5e83.png";